import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import apiObj from '@a/js/api.js'

// 样式重置
import '@/assets/styles/reset.css'
import '@/assets/styles/pcsty.less'

Vue.config.devtools = apiObj.VUE_APP_NAME !== 'production'

// import { Button, Toast } from 'vant'

// Vue.use(Button)
// Vue.use(Toast)

Vue.config.productionTip = false
Vue.prototype.$AppName = 'inspect'
Vue.prototype.$imgmark = '1632705818430'

new Vue({
  router,
  data: () => {
    return {
      isVersion: 0,
    }
  },
  render: h => h(App)
}).$mount('#app')
